import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';

function MonthSelector({ value, onChange, label }) {
  const labelText = label !== undefined ? label : "Mois";
  const monthsList = [];
  const currentDate = new Date();
  
  // Générer les 12 derniers mois
  for (let i = 0; i < 12; i++) {
    const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
    const monthValue = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0');
    const monthLabel = date.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long' });
    monthsList.push({ value: monthValue, label: monthLabel });
  }

  return (
    <div className="space-y-2">
      {labelText && <Label>{labelText}</Label>}
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Tous les mois" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tous les mois</SelectItem>
          {monthsList.map(function(month) {
            return (
              <SelectItem key={month.value} value={month.value}>
                {month.label}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
}

export default MonthSelector;
